export default __webpack_public_path__ + "static/media/appLogo2V2.60a54a6e.png";